import { stylesheet } from "typestyle";

const styles = stylesheet({
  root: {},
});

export default styles;
